import { put, takeLatest, all, call } from "redux-saga/effects";
import { toast } from "react-toastify";
import { GET_MODULE_LIST } from "../../Actions/types";
import { getModuleListSuccess, getModuleListFailure } from "../../Actions/module/moduleList-actions"
import api from "../../../helper/api";

function* fetchModuleList(action) {
  try {
    const response = yield api.get("admin/modules/list");
    if (response?.status === 200 && response.data?.status === 200) {
      yield call(action?.payload?.callback, response?.data?.data);
      yield put(getModuleListSuccess({ data: response?.data?.data }));
    } else {
      toast.error(response?.data?.message);
    }
  } catch (e) {
    yield put(getModuleListFailure({ error: e }));
  }
}

function* moduleListWatcher() {
  yield takeLatest(GET_MODULE_LIST, fetchModuleList);
}

export default function* ModuleListSaga() {
  yield all([moduleListWatcher()]);
}
